import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useToast } from "@chakra-ui/react";
import logout from "./logout";
import { clearUser } from "../store/userSlice";
import { secureFetch } from "../data/secureFetch";

const SessionValidator = () => {
  const currentUser = useSelector((state) => state.user.uid);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toast = useToast();

  useEffect(() => {
    if (currentUser) {
      // Periodically check session validity and refresh the token
      const interval = setInterval(async () => {
        try {
          // Call the refresh token API endpoint
          const response = await secureFetch(`/api/auth/refresh-token`, {
            method: "POST",
            credentials: "include", // Ensure cookies are sent
          });

          if (!response.ok) throw new Error("Failed to refresh token");

          // Handle response if needed
        } catch (error) {
          console.error("Session validation failed:", error);
          dispatch(clearUser());
          toast({
            title: "Logged out",
            description:
              "Your session has expired, and you've been logged out.",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
          logout(toast, navigate);
        }
      }, 1000 * 60 * 20); // Check every 20 minutes

      return () => clearInterval(interval);
    }
  }, [currentUser, dispatch, navigate, toast]);

  return null;
};

export default SessionValidator;
